import * as React from 'react';

export function useOnScreen<T extends HTMLElement>(
  rootMargin = '400px',
  initialState = false,
): [boolean, React.MutableRefObject<T | null>] {
  const [isIntersecting, setIntersecting] = React.useState(initialState);
  const ref = React.useRef<T>(null);

  React.useEffect(() => {
    const currentRef = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIntersecting(entry.isIntersecting);
      },
      {
        rootMargin,
      },
    );
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [rootMargin]);

  return [isIntersecting, ref];
}
